import { Component } from '@angular/core';
import { UserService } from "src/app/services/firebase/user.service";


@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
})
export class AdminComponent {

  password: string = '20221003'
  quantity: string = '100'
  starting: string = '100'

  constructor(
    private userService: UserService,
  ) { }

  generateUsers() {
    const starting = Number(this.starting)
    const quantity = Number(this.quantity)
    const total = starting + quantity
    const half = quantity / 2

    for (let i = starting; i <= total; i++) {
      const userWithTraining = (i <= (starting + half))
      const username = 'user' + String(i).padStart(3, '0');
      const password = this.password

      this.userService.create({
        admin: false,
        training: userWithTraining,
        username,
        password
      })
    }
  }

  async deleteRegularUsers() {
    const subscription = this.userService
      .getAll()
      .subscribe(users => {
        subscription.unsubscribe()
        for (const user of users) {
          if (!user.admin) {
            this.userService.delete(user.id)
          }
        }
      })
  }
}
